var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2177 3.83807C27.7104 3.59174 28.2903 3.59174 28.783 3.83807L52.1163 15.5047C52.7092 15.8012 53.0837 16.4071 53.0837 17.07V40.4033C53.0837 41.0662 52.7092 41.6721 52.1163 41.9686L28.783 53.6352C28.2903 53.8816 27.7104 53.8816 27.2177 53.6352L3.88437 41.9686C3.2915 41.6721 2.91699 41.0662 2.91699 40.4033V17.07C2.91699 16.4071 3.2915 15.8012 3.88437 15.5047L27.2177 3.83807ZM6.41699 18.1515V39.3218L28.0003 50.1134L49.5837 39.3218V18.1515L28.0003 7.35988L6.41699 18.1515Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10213 16.2872C3.53436 15.4227 4.58554 15.0723 5.45 15.5046L28.7833 27.1712C29.6478 27.6035 29.9982 28.6546 29.566 29.5191C29.1337 30.3836 28.0825 30.7339 27.2181 30.3017L3.88475 18.635C3.02029 18.2028 2.6699 17.1516 3.10213 16.2872Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0003 26.9867C28.9668 26.9867 29.7503 27.7702 29.7503 28.7367V52.07C29.7503 53.0365 28.9668 53.82 28.0003 53.82C27.0338 53.82 26.2503 53.0365 26.2503 52.07V28.7367C26.2503 27.7702 27.0338 26.9867 28.0003 26.9867Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8993 16.2872C53.3315 17.1516 52.9811 18.2028 52.1167 18.635L28.7833 30.3017C27.9189 30.7339 26.8677 30.3836 26.4355 29.5191C26.0032 28.6546 26.3536 27.6035 27.2181 27.1712L50.5514 15.5046C51.4159 15.0723 52.4671 15.4227 52.8993 16.2872Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2326 10.4538C41.6649 11.3183 41.3145 12.3695 40.45 12.8017L17.1167 24.4684C16.2522 24.9006 15.201 24.5502 14.7688 23.6858C14.3366 22.8213 14.687 21.7701 15.5514 21.3379L38.8848 9.67122C39.7492 9.23899 40.8004 9.58938 41.2326 10.4538Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdProduct);
export default __webpack_public_path__ + "static/media/ad-product.f4fe4837.svg";
export { ForwardRef as ReactComponent };